var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sameday-times',{attrs:{"settings":_vm.settings,"times":_vm.times},on:{"on:form":function($event){return _vm.$emit('on:form', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }